export const getInitialValue = ({ slug }) => ({
  slug
})
